import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../components/WebView/icons/More.svg'


const _withScopeId = n => (_pushScopeId("data-v-ebef3fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Filter Bar", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Scatter Plot", -1))
const _hoisted_3 = {
  key: 0,
  class: "ts-kebab-item"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Actions"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBarDownload = _resolveComponent("FilterBarDownload")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass([{ hide: _ctx.hideKebabOptions }, "ts-kebab box"])
    }, [
      _createElementVNode("div", {
        class: "ts-kebab-item",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    _ctx.toggleKebabOption(
                        'setTsFilterBarVisible',
                        !_ctx.tsFilterBarVisible
                    )
                ))
      }, [
        _hoisted_1,
        _createElementVNode("div", {
          class: _normalizeClass([
                        'ts-kebab-toggle',
                        { 'ts-kebab-off': !_ctx.tsFilterBarVisible },
                    ])
        }, _toDisplayString(_ctx.tsFilterBarVisible ? 'On' : 'Off'), 3)
      ]),
      _createElementVNode("div", {
        class: "ts-kebab-item",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
                    _ctx.toggleKebabOption(
                        'setTsScatterPlotVisible',
                        !_ctx.tsScatterPlotVisible
                    )
                ))
      }, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass([
                        'ts-kebab-toggle',
                        { 'ts-kebab-off': !_ctx.tsScatterPlotVisible },
                    ])
        }, _toDisplayString(_ctx.tsScatterPlotVisible ? 'On' : 'Off'), 3)
      ]),
      (_ctx.tsMobileData.enabledExecutiveReporting && !_ctx.tsMobileView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_FilterBarDownload, {
              "show-download-button": false,
              onToggle: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideKebabOptions = true))
            })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      id: "actions",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideKebabOptions = !_ctx.hideKebabOptions))
    }, _hoisted_5)
  ])), [
    [_directive_click_outside, _ctx.clickOut]
  ])
}